var React = require('react');
import Autocomplete from 'react-autocomplete';
import beerTypes from './autofill/beerTypes.js'

class AddSample extends React.Component {

    constructor() {
        super();
        this.state = {value: ''}
        this.items = this.items.bind(this);
    }

    items() {
        const val = this.state.value.toLowerCase();

        if (val.length > 0) {
            return beerTypes.filter((item) => {
                const label = item.label.toLowerCase();
                return label.includes(val)
            })
        } else {
            return beerTypes;
        }
    }

    render() {
        return (
            <div className="w100">
                <Autocomplete
                    className={'form-input'}
                    wrapperStyle={{width: '100%'}}
                    inputProps={
                        {
                            placeholder: 'Beer style, if applicable (ex. type "IPA")',
                            className: 'form-input big-input',
                            name: 'beer_type',
                            id: 'beer_type'
                        }
                    }
                    getItemValue={(item) => item.label}
                    items={this.items()}
                    renderItem={(item, isHighlighted) =>
                        <div style={{background: isHighlighted ? 'lightgray' : 'white'}}>
                            {item.label}
                        </div>
                    }
                    value={this.state.value}
                    onChange={(e) => this.setState({value: e.target.value})}
                    onSelect={(val) => this.setState({value: val})}
                />
            </div>
        );
    }
}

export default AddSample